import React, {useState} from "react";
import {css} from "@emotion/css";
import {Alert, AlertTitle} from "@mui/lab";
import {FormControl, Grid} from "@mui/material";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthDispatcher, useAuthState} from "../../context/AuthContext";
import {useNavigate} from "react-router-dom";
import {doUserLoginOut} from "../Sidebar/logout/LogOut";
import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoMaterialOutlinedInput, RaikoSectionContainer
} from "@moeindal/base-raiko-panel-components";

const ChangeUserName = (
    {
        adminId = -1,
        service,
        hint = "بعد از تغییر نام کاربری به صورت خودکار از برنامه خارج می شوید و لازم است مجددا با نام کاربری جدید وارد برنامه شوید.",
        refreshDetailInfo
    }) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()

    const [username, setUsername] = useState("");

    const navigate = useNavigate()
    const dispatch = useAuthDispatcher()


    function changeUserName() {
        if (username.length > 7) {
            loading(setLoadingStateDispatch(true))

            if (adminId >= 0)
                updateManagerUserName()
            else
                updateOwnAdminUsername()


        } else {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "نام کاربری باید حداقل 8 کاراکتر باشد!"))
        }
    }

    function updateManagerUserName() {
        service.updateManagerUserNameById(adminId, username)
            .then(response => {
                loading(setLoadingStateDispatch(false))
                if (refreshDetailInfo)
                    refreshDetailInfo()
                setUsername("")
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "نام کاربری با موفقیت تغییر پیدا کرد!"))
            }).catch(reason => {
            loading(setLoadingStateDispatch(false))

            if (reason.response.status === 409) {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "نام کاربری وارد شده تکراری می باشد!"))
            } else
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در تغییر نام کاربری"))
        })
    }

    function updateOwnAdminUsername() {
        service.updateUserName(username)
            .then(response => {
                loading(setLoadingStateDispatch(false))
                setUsername("")
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "نام کاربری با موفقیت تغییر پیدا کرد!"))

                if (adminId === -1)
                    doUserLoginOut(dispatch, navigate)
            }).catch(reason => {
            loading(setLoadingStateDispatch(false))

            if (reason.response.status === 409) {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "نام کاربری وارد شده تکراری می باشد!"))
            } else
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در تغییر نام کاربری"))
        })
    }

    return (
        <RaikoBaseCardContainer className={css`margin-top: 1rem`}>
            <RaikoGridOneColumn>
                <RaikoSectionContainer
                    title={"ویرایش نام کاربری"}
                    hasActionButton
                    actionButtonOnclick={changeUserName}
                >
                    <RaikoGridOneColumn>
                        <Alert severity="error" className={css`width: 100%;`}>
                            <AlertTitle>لطفا نکات زیر را مورد توجه قرار دهید:</AlertTitle>
                            <div className={css`display: flex;
                          flex-direction: column;
                          gap: 8px;
                        `}>
                                <span>{hint}</span>

                            </div>
                        </Alert>
                        <FormControl fullWidth>
                            <RaikoMaterialOutlinedInput
                                labelText={"نام کاربری جدید"}
                                placeHolder={"لطفا کاربری مورد نظر را وارد نمایید..."}
                                value={username}
                                setValue={setUsername}
                                onChange={e => setUsername(e.target.value)}
                            />
                        </FormControl>
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}
export default ChangeUserName